import { motion } from "framer-motion";
import { Clock, Users, Check } from "lucide-react";
import { Card } from "@/components/ui/card";

const benefits = [
  {
    title: "Pre-arrival Queuing",
    description: "Let customers join your queue before arriving, perfect for restaurants during peak hours.",
    icon: Clock,
  },
  {
    title: "Reduce Crowding",
    description: "Eliminate physical queues and improve social distancing with virtual waiting lines.",
    icon: Users,
  },
  {
    title: "Customer Satisfaction",
    description: "Keep customers informed with real-time updates and accurate wait times.",
    icon: Check,
  },
];

export const BenefitsSection = () => {
  return (
    <section className="py-16 px-4">
      <div className="container mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold mb-4 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            Key Benefits
          </h2>
          <p className="text-muted-foreground">
            Discover how QR code queuing can transform your business
          </p>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <Card className="p-6 bg-secondary/50 border-none hover:bg-secondary/70 transition-colors">
                <benefit.icon className="w-12 h-12 text-accent mb-4" />
                <h3 className="text-lg font-semibold mb-2">{benefit.title}</h3>
                <p className="text-muted-foreground">{benefit.description}</p>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};